module.exports = __webpack_public_path__ + "assets/img/BKM_Logo-Footer.fd8ecece.png";